import { Blackjack2Record, Blackjack2Result } from '@/models/games/blackjack2';
import { GameState } from '@/models/games/blackjack2/enums/GameState';
import { RecordState } from '@/models/games/blackjack2/enums/RecordState';
import { WinState } from '@/models/games/blackjack2/enums/WinState';
import { ResultInfo } from '@/models/games/blackjack2/GameInfo';
import { LocalState } from '@/models/games/enums/LocalState';
import { getShoeRoundByGameCount } from '../commonFunc';

export const getRecordState = (
    win: WinState | undefined,
    point: string
): RecordState | undefined => {
    if (point == 'B') {
        return RecordState.BUSH;
    }
    if (point == 'BJ') {
        return RecordState.BJ;
    }
    if (win == undefined) return undefined;
    switch (win) {
        case WinState.Lose:
            return RecordState.Lose;
        case WinState.Win:
            return RecordState.Win;
        case WinState.Push:
            return RecordState.Push;
    }
    return RecordState.None;
};
export const convertResultToRecord = (
    resultInfo: ResultInfo,
    game_id: number
): Blackjack2Record => {
    const r = {} as Blackjack2Record;
    const currentResult = {
        dealer: resultInfo.dealer,
        seatInfos: resultInfo.seats_info,
        winset: resultInfo.winset,
        GameID: game_id,
    } as Blackjack2Result;
    const { Shoe, Round } = getShoeRoundByGameCount(currentResult.GameCount);
    let results = [[0], [0], [0], [0], [0], [0], [0], [0]];
    if (currentResult.dealer) {
        switch (currentResult.dealer.cp) {
            case 'BJ':
                results[0][0] = RecordState.BJ;
                break;
            case 'B':
                results[0][0] = RecordState.BUSH;
                break;
        }
    }
    for (let i = 0; i < currentResult.seatInfos.length; i++) {
        const seat = currentResult.seatInfos[i];
        if (seat.h1.r) {
            let tmp = getRecordState(seat.h1.r, seat.h1.cp);
            results[seat.seat_num][0] =
                tmp !== undefined ? tmp : RecordState.None;
            if (seat.is_split && seat.h2.r) {
                tmp = getRecordState(seat.h2.r, seat.h2.cp);
                results[seat.seat_num].push(
                    tmp !== undefined ? tmp : RecordState.None
                );
            }
        }
    }
    r.gameID = currentResult.GameID;
    r.shoes = Shoe;
    r.round = Round;
    r.dealerPoint = currentResult.dealer.cp;
    r.seatsResult = results;
    return r;
};

export const getBlackjack2LocalState = (
    isRest: boolean,
    state: number,
    isGameResultReleased: boolean,
    isRoundCancel: boolean
) => {
    if (isRest) {
        return LocalState.REST;
    }
    switch (state) {
        case GameState.Idle:
        case GameState.Ready:
            return LocalState.IDLE;
        case GameState.Shuffle:
            if (isRoundCancel) return LocalState.ROUND_CANCEL;
            return LocalState.SHUFFLING;
        case GameState.Betting:
            return LocalState.BETTING;
        case GameState.Started:
        case GameState.GameResult:
            if (isGameResultReleased) {
                return LocalState.RESULT;
            }
            return LocalState.DEALING;
    }
    return LocalState.DEALING;
};
